<template>
  <div class="aside-navigation-menu-with-collapse">
    <el-menu
      :collapse-transition="false"
      :collapse="collapse"
      router
      :default-active="defaultActivePath"
      style="overflow-x: hidden;background-color:#F8FFFF;z-index:999;padding-bottom:40px;"
      @open="handleOpen"
      @close="handleClose"
      ref="menus"
    >
      <div v-if="isMiniShow" @click.stop="handleShowMenuBar"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="bars" class="svg-inline--fa fa-bars " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style="margin-right: auto; color: rgb(50, 50, 50); cursor: pointer;margin-left: 18px; margin-top:25px;font-size: 20px;width:20px;height:20px"><path fill="currentColor" d="M0 96C0 78.33 14.33 64 32 64H416C433.7 64 448 78.33 448 96C448 113.7 433.7 128 416 128H32C14.33 128 0 113.7 0 96zM0 256C0 238.3 14.33 224 32 224H416C433.7 224 448 238.3 448 256C448 273.7 433.7 288 416 288H32C14.33 288 0 273.7 0 256zM416 448H32C14.33 448 0 433.7 0 416C0 398.3 14.33 384 32 384H416C433.7 384 448 398.3 448 416C448 433.7 433.7 448 416 448z"></path></svg></div>
      <div v-if="!isMiniShow" style="height:45px;background: #F8FFFF;">
        <!-- <div style="float: left;margin-top:30px;margin-left:28px;color:rgb(89,89,89);"><svg width="20px" height="20px" viewBox="0 0 24 12" fill="currentcolor" xmlns="http://www.w3.org/2000/svg" class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-oy3l7l" focusable="false" aria-hidden="true"><path d="M12 0.25C5.75 0.25 0.75 5.28906 0.75 11.5C0.75 13.5703 1.29688 15.5234 2.27344 17.1641C2.46875 17.5547 2.89844 17.75 3.32812 17.75H20.6328C21.0625 17.75 21.4922 17.5547 21.6875 17.1641C22.6641 15.5234 23.25 13.5703 23.25 11.5C23.25 5.28906 18.2109 0.25 12 0.25ZM12 2.75C12.5469 2.75 13.0156 3.17969 13.1719 3.6875C13.1328 3.76562 13.0547 3.84375 13.0156 3.96094L12.6641 5.01562C12.4688 5.17188 12.2344 5.25 12 5.25C11.2969 5.25 10.75 4.70312 10.75 4C10.75 3.33594 11.2969 2.75 12 2.75ZM4.5 14C3.79688 14 3.25 13.4531 3.25 12.75C3.25 12.0859 3.79688 11.5 4.5 11.5C5.16406 11.5 5.75 12.0859 5.75 12.75C5.75 13.4531 5.16406 14 4.5 14ZM6.375 7.75C5.67188 7.75 5.125 7.20312 5.125 6.5C5.125 5.83594 5.67188 5.25 6.375 5.25C7.03906 5.25 7.625 5.83594 7.625 6.5C7.625 7.20312 7.03906 7.75 6.375 7.75ZM15.9844 4.9375L13.6016 12.125C14.1484 12.5938 14.5 13.2578 14.5 14C14.5 14.4688 14.3438 14.8984 14.1484 15.25H9.8125C9.61719 14.8984 9.5 14.4688 9.5 14C9.5 12.7109 10.5156 11.6172 11.8047 11.5391L14.2266 4.35156C14.3828 3.84375 14.8906 3.57031 15.3984 3.76562C15.9062 3.92188 16.1406 4.46875 15.9844 4.9375ZM16.5703 7.16406L17.1562 5.36719C17.3125 5.28906 17.4688 5.28906 17.625 5.28906C18.2891 5.28906 18.875 5.83594 18.875 6.53906C18.875 7.20312 18.2891 7.78906 17.625 7.78906C17.1562 7.75 16.8047 7.51562 16.5703 7.16406ZM19.5 14C18.7969 14 18.25 13.4531 18.25 12.75C18.25 12.0859 18.7969 11.5 19.5 11.5C20.1641 11.5 20.75 12.0859 20.75 12.75C20.75 13.4531 20.1641 14 19.5 14Z"></path></svg><span style="margin-left: 5px;font-size:14px;font-weight:500px">ダッシュボード</span></div> -->
        <div style="float: right;margin-right:15px;margin-top:15px;" @click.stop="handleLock">
          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="xmark" class="svg-inline--fa fa-xmark " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" style="margin-right:5px;margin-top:5px; margin-left:5px;width:21px;height:21px; color: rgb(50, 50, 50); cursor: pointer; font-size: 22px;"><path fill="currentColor" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"></path></svg>
        </div>
        <div style="float: right;margin-right:-4px;margin-top:17px;" @click.stop="handleLock()">
          <svg v-if="!isLock" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="thumbtack" class="svg-inline--fa fa-thumbtack " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 513" style="margin-right: 5px;margin-top:5px; margin-left: 5px;width:18px;height:18px;  color: rgb(50, 50, 50); cursor: pointer; font-size: 17px; transform: rotate(45deg); transition: all 0.2s ease 0s;"><path fill="currentColor" d="M32 32C32 14.33 46.33 0 64 0H320C337.7 0 352 14.33 352 32C352 49.67 337.7 64 320 64H290.5L301.9 212.2C338.6 232.1 367.5 265.4 381.4 306.9L382.4 309.9C385.6 319.6 383.1 330.4 377.1 338.7C371.9 347.1 362.3 352 352 352H32C21.71 352 12.05 347.1 6.04 338.7C.0259 330.4-1.611 319.6 1.642 309.9L2.644 306.9C16.47 265.4 45.42 232.1 82.14 212.2L93.54 64H64C46.33 64 32 49.67 32 32zM224 384V480C224 497.7 209.7 512 192 512C174.3 512 160 497.7 160 480V384H224z"></path></svg>
          <svg v-if="isLock" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="thumbtack" class="svg-inline--fa fa-thumbtack " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 513" style="margin-right:5px;margin-top:5px;  margin-left:5px;width:18px;height:18px; color: #64B0B2; cursor: pointer; font-size: 17px; transition: all 0.2s ease 0s;"><path fill="currentColor" d="M32 32C32 14.33 46.33 0 64 0H320C337.7 0 352 14.33 352 32C352 49.67 337.7 64 320 64H290.5L301.9 212.2C338.6 232.1 367.5 265.4 381.4 306.9L382.4 309.9C385.6 319.6 383.1 330.4 377.1 338.7C371.9 347.1 362.3 352 352 352H32C21.71 352 12.05 347.1 6.04 338.7C.0259 330.4-1.611 319.6 1.642 309.9L2.644 306.9C16.47 265.4 45.42 232.1 82.14 212.2L93.54 64H64C46.33 64 32 49.67 32 32zM224 384V480C224 497.7 209.7 512 192 512C174.3 512 160 497.7 160 480V384H224z"></path></svg>
        </div>
      </div>
        <el-menu-item
          v-for="menuItem in menuItems"
          v-if="menuItem.children.length == 0"
          :key="menuItem.menuCd"
          :index="String(menuItem.urlPath)"
          :class="'menu'"
        >
          <i :class="menuItem.menuCss==null?'no-icon-submenu-item':menuItem.menuCss"/>
          <span>{{ menuItem.menuNm }}</span>
        </el-menu-item>
        <el-submenu
          v-else
          :key="menuItem.menuCd"
          :index="String(menuItem.menuCd)"
        >
          <!--<hr style="width:86%;height:1px;border: none;border-top:3px double;background-color:#F8FFFF;margin-top:-3px;"/>-->
          <el-menu-item
            v-for="subMenuItem in menuItem.children"
            :key="subMenuItem.menuCd"
            :index="String(subMenuItem.urlPath)"
            :class="'menu'"
          >
            <i :class="subMenuItem.menuCss==null?'no-icon-submenu-item':subMenuItem.menuCss"/>
            <span>{{ subMenuItem.menuNm }}</span>
          </el-menu-item>
          <template #title style="height: 35px!important;">
            <i :class="menuItem.menuCss==null?'no-icon-submenu-item':menuItem.menuCss"/>
            <span>{{ menuItem.menuNm }}</span>
          </template>
        </el-submenu>
    </el-menu>
    <div style="height: 100px"></div>
  </div>
</template>

<script>
export default {
  name: 'AsideNavigationMenuWithCollapse',
  props: {
    activeTagIndex: String,
    width: String,
    menuItems: {
      type: Array,
      required: true
    }
  },
  //watch: {
  //  $route() {
  //    //路由变化时就重新执行这个方法更新传来的参数
  //    this.getRouter();
  //  }
  //},
  inject:['reload'],
  data() {
    return {
      popContainer:'',
      isMiniShow:false,
      isLock:true,
      dialogVisible: false,
      collapse: false,
      height: ''
    }
  },
  methods: {
    loadPage: function(item) {
      if (item.urlPath) {
        this.$store.commit('saveMenuCd', item.menuCd)
        this.activeTagIndex = item.urlPath
        this.$router.push({name: item.urlPath})
      }
    },
    getRouter() {
      //if(this.$route.path == this.activeTagIndex){
        //this.reload()
     // }
    },//路由变化后导航栏刷新
    handleCancel() {
      this.$confirm('确定要登出吗？', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        cancelButtonClass: 'clean-button',
        confirmButtonClass: 'common-button'
      }).then(() => {
        this.axios.post('logout').then(response => {
          // this.$router.push({name: 'login'})
          this.$store.dispatch('logout')
          //this.$keycloak.logout({redirectUri: this.$store.state.loginUser.geIndexUrl})
        })
      }).catch((e) => {
        return true
      })
    },
    handleOpen(key, keyPath) {
      //this.$refs.menus.open(keyPath);
    },
    handleClose(key, keyPath) {
      //this.$refs.menus.open(keyPath);
    },
    listFilter(list) {
      return list.filter(function(item) {
        return item.children.length > 0
      })
    },
    handleLock() {
      if (this.collapse) {
        this.collapse = false
        this.isMiniShow = false
      } else {
        this.collapse = true
        this.isMiniShow = true
      }
      this.popContainer = ''
      this.$emit('switchHandle', this.collapse);
    },
    handleLock() {
      if (this.isLock) {
        this.$emit('switchHandle', true);
        this.isLock = false;
        this.popContainer = 'popContainer'
      } else {
        this.$emit('switchHandle', false);
        this.isLock = true;
        this.popContainer = ''
      }
    },
    handleShowMenuBar() {
      this.isMiniShow = false
      this.collapse = false
      let lockShow = false
      if (!this.isLock) {
        this.popContainer = 'popContainer'
        lockShow = true
      }
      this.$emit('switchHandle', lockShow);
    },
    clickPopContainer() {
      this.popContainer = ''
      this.isMiniShow = true
      this.collapse = true
      this.$emit('switchHandle', this.collapse);
    }
  },
  computed: {
    defaultActivePath() {
      return _.isEmpty(this.activeTagIndex) ? '/sws/platform/init' : this.activeTagIndex
    },
  }
}
</script>
<style scoped>
.el-menu {
  /*background-color: #fd6925;*/
  /*min-height: calc(100vh - 100px);*/
  height: calc(100vh - 100px);
  float: left;
  z-index: 13;
  width: 100%;
}

.el-menu .el-submenu, .el-menu-item {
  background-color: #F8FFFF;
  color: rgb(89,89,89);
}

.el-menu .el-menu-item:hover {
  background-color: #AED7D8;
}

.el-menu-item.is-active {
  background-color: #64B0B2;
  color: white;
}

.el-submenu__title i, .el-menu-item i {
  color: rgb(89,89,89);
}
el-submenu__title span {
  color: rgb(89,89,89);
}
</style>
<style>
.aside-navigation-menu-with-collapse .el-submenu__title:hover {
  background-color: rgb(254 ,186 ,156);
}
.aside-navigation-menu-with-collapse .el-menu:not(.el-menu--collapse){
  width: 240px;
}
.menu {
  height: 45px!important;
  font-weight: bold;
}
.el-submenu__title {
  height: 45px!important;
  font-weight: bold;
}
</style>

